module.exports = __webpack_public_path__ + "img/member-team5.f179d317.jpg";